module.exports = __webpack_public_path__ + "media/images/expert__calvin-stettler-4c9b0e76088cd46f62a6b455d1e1c3cb.png";